import React from 'react';
import Icon from '../../../components/AppIcon';

const ProblemSection = () => {
  const problems = [
    {
      id: 1,
      icon: "Thermometer",
      title: "AC Tidak Dingin",
      description: "Ruangan tetap panas meski AC sudah menyala seharian",
      temperature: "32°C",
      ideal: "24°C"
    },
    {
      id: 2,
      icon: "Zap",
      title: "Tagihan Listrik Tinggi",
      description: "Konsumsi listrik membengkak hingga 2x lipat dari biasanya",
      cost: "Rp 2.5 Juta",
      normal: "Rp 1.2 Juta"
    },
    {
      id: 3,
      icon: "Volume2",
      title: "Suara Berisik",
      description: "Bunyi aneh dan getaran mengganggu kenyamanan keluarga",
      noise: "Sangat Berisik",
      level: "85 dB"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading font-bold text-3xl lg:text-5xl text-foreground mb-6">
            Masalah AC Yang Sering Dialami?
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Jangan biarkan masalah AC mengganggu kenyamanan keluarga dan bisnis Anda. 
            Kami siap membantu mengatasi semua keluhan AC dengan solusi terpercaya.
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {problems?.map((problem) => (
            <div key={problem?.id} className="bg-white rounded-2xl p-8 shadow-card hover:shadow-lg transition-all duration-300 border border-border">
              {/* Icon */}
              <div className="w-16 h-16 bg-destructive/10 rounded-2xl flex items-center justify-center mb-6">
                <Icon name={problem?.icon} size={32} className="text-destructive" />
              </div>

              {/* Content */}
              <h3 className="font-heading font-bold text-xl text-foreground mb-4">
                {problem?.title}
              </h3>
              <p className="text-muted-foreground mb-6 leading-relaxed">
                {problem?.description}
              </p>

              {/* Metrics */}
              <div className="space-y-3">
                {problem?.temperature && (
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">Suhu Saat Ini:</span>
                    <span className="font-bold text-destructive">{problem?.temperature}</span>
                  </div>
                )}
                {problem?.cost && (
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">Tagihan Bulanan:</span>
                    <span className="font-bold text-destructive">{problem?.cost}</span>
                  </div>
                )}
                {problem?.noise && (
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">Tingkat Kebisingan:</span>
                    <span className="font-bold text-destructive">{problem?.level}</span>
                  </div>
                )}

                {/* Ideal State */}
                <div className="pt-3 border-t border-border">
                  {problem?.ideal && (
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-muted-foreground">Suhu Ideal:</span>
                      <span className="font-bold text-secondary">{problem?.ideal}</span>
                    </div>
                  )}
                  {problem?.normal && (
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-muted-foreground">Tagihan Normal:</span>
                      <span className="font-bold text-secondary">{problem?.normal}</span>
                    </div>
                  )}
                  {problem?.noise && (
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-muted-foreground">Setelah Diperbaiki:</span>
                      <span className="font-bold text-secondary">&lt; 40 dB</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Temperature Gauge Visualization */}
        <div className="bg-white rounded-2xl p-8 shadow-card">
          <div className="text-center mb-8">
            <h3 className="font-heading font-bold text-2xl text-foreground mb-4">
              Perbandingan Suhu Ruangan
            </h3>
            <p className="text-muted-foreground">
              Lihat perbedaan suhu sebelum dan sesudah perbaikan AC profesional
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Before */}
            <div className="text-center">
              <div className="relative w-32 h-32 mx-auto mb-4">
                <div className="w-full h-full rounded-full bg-destructive/20 flex items-center justify-center">
                  <div className="w-24 h-24 rounded-full bg-destructive flex items-center justify-center">
                    <span className="text-white font-bold text-xl">32°C</span>
                  </div>
                </div>
                <Icon name="TrendingUp" size={24} className="absolute -top-2 -right-2 text-destructive" />
              </div>
              <h4 className="font-heading font-bold text-lg text-destructive mb-2">Sebelum Diperbaiki</h4>
              <p className="text-sm text-muted-foreground">Ruangan panas & tidak nyaman</p>
            </div>

            {/* After */}
            <div className="text-center">
              <div className="relative w-32 h-32 mx-auto mb-4">
                <div className="w-full h-full rounded-full bg-secondary/20 flex items-center justify-center">
                  <div className="w-24 h-24 rounded-full bg-secondary flex items-center justify-center">
                    <span className="text-white font-bold text-xl">24°C</span>
                  </div>
                </div>
                <Icon name="TrendingDown" size={24} className="absolute -top-2 -right-2 text-secondary" />
              </div>
              <h4 className="font-heading font-bold text-lg text-secondary mb-2">Setelah Diperbaiki</h4>
              <p className="text-sm text-muted-foreground">Sejuk & hemat listrik</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;